<template>
  <div id="app">
    <router-view v-title="title"/>
  </div>
</template>

<script>
import util from './util.js'
export default {
    name: 'App',
    methods: {},
    components: {

    },
    computed: {
        title () {
            if(util.getCookie('storeId')) {
                return this.$store.getters['shop']['storeName'] || `${this.$store.getters['shop']['mobile']}的微店铺`
            } else {
                return this.$store.getters['getSiteInfo']['siteName'];
            }
        },

    }
}
</script>

<style>
  #nb_invite_wrap{
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue